import React from 'react';
import { Box, Container, Stack, Typography } from '@mui/material';

export const Section = ({ id, bg = 'background.default', children, sx }) => (
  <Box component="section" id={id} sx={{ bgcolor: bg, py: { xs: 8, md: 12 }, scrollMarginTop: '72px', ...sx }}>
    <Container maxWidth="lg">{children}</Container>
  </Box>
);

export const Heading = ({ title, text, light, sx }) => (
  <Box sx={{ maxWidth: 720, mb: { xs: 5, md: 7 }, ...sx }}>
    <Typography variant="h3" component="h2" sx={{ color: light ? '#fff' : 'primary.dark', mb: 2, fontSize: { xs: '2rem', md: '2.6rem' }, lineHeight: 1.1 }}>
      {title}
    </Typography>
    {text && (
      <Typography sx={{ color: light ? 'rgba(255,255,255,0.78)' : 'text.secondary', fontSize: '1.08rem', lineHeight: 1.75 }}>
        {text}
      </Typography>
    )}
  </Box>
);

export const Img = ({ src, alt, sx }) => (
  <Box component="img" src={src} alt={alt} sx={{ display: 'block', width: '100%', height: '100%', objectFit: 'cover', ...sx }} />
);

export const BulletList = ({ items, light }) => (
  <Stack component="ul" spacing={1.5} sx={{ listStyle: 'none', m: 0, p: 0 }}>
    {items.map((t) => (
      <Stack component="li" key={t} direction="row" spacing={1.75} alignItems="flex-start">
        <Box sx={{ width: 8, height: 8, mt: '10px', flexShrink: 0, borderRadius: '50%', bgcolor: 'secondary.main' }} />
        <Typography sx={{ color: light ? 'rgba(255,255,255,0.88)' : 'text.primary', lineHeight: 1.65 }}>{t}</Typography>
      </Stack>
    ))}
  </Stack>
);
